import React, { useEffect, useState } from "react";
import DashBoardNotifcation from "../../global/DashBoardNotifcation/DashBoardNotifcation";
import { Margin } from "@mui/icons-material";
import { Box, Button, Typography, useTheme } from "@mui/material";
import { useGetAllNotification } from "../../global/Hooks";
import useDeviceType from "../../global/Hooks/useDeviceType";
import useDashboardLogic from "../../global/DashBoardNotifcation/useDashboardLogic";

function UserNotifactionMessage() {
  const theme = useTheme().palette.mode;
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));
  const { data } = useGetAllNotification(userInfo?.userId);
  const { state, action } = useDashboardLogic(data, userInfo?.userId);
  const { typeHandler, seenMessage, seenAllMessage } = action;
  const [boxWidth, setBoxWidth] = useState("370px");
  useEffect(() => {
    if (window.innerWidth < 980) {
      setBoxWidth("100%");
    } else {
      setBoxWidth("100%");
    }
  }, [window]);
  const deviceType = useDeviceType();
  return (
    <Box
      sx={{
        background:  theme === "dark"&&deviceType != "mobile" ? "#262D39" : deviceType != "mobile"?"#FFF":"unset",
        boxShadow:
          deviceType != "mobile"
            ? "0px 1px 2px 0px rgba(0, 0, 0, 0.14)"
            : "unset",
        borderRadius: "1rem",
        padding: deviceType != "mobile"?"1rem":"0",
        marginY: deviceType != "mobile"?"1rem":"0",
      }}
    >
      <Box  sx={{
        display: "flex",
        placeContent: "space-between"
      }}>
      <Typography>پیام ها</Typography>
          <Button
            onClick={seenAllMessage}
            style={{ color: "#1E6AFD", fontSize: "12px" }}
          >
            خواندن همه
          </Button>
        </Box>
      <DashBoardNotifcation
        data={data}
        disableHeader={true}
        userId={userInfo.userId}
        width={boxWidth}
        heigth={deviceType != "mobile" ? "25rem" : "auto"}
      />
    </Box>
  );
}

export default UserNotifactionMessage;
